import { createContext, useContext, type Dispatch, type SetStateAction } from 'react';

// Define the type for a single chat message
export type ChatMessage = {
  id: string;
  role: 'user' | 'assistant';
  content: string;
};

// Define the type for the context's value
interface ChatContextType {
  chatMessages: ChatMessage[];
  messageInput: string;
  setMessageInput: Dispatch<SetStateAction<string>>;
  sendTextMessage: () => void;
  sendAudioMessage: (blob: Blob) => void;
}

// Create the context with a default value that matches the type
const ChatContext = createContext<ChatContextType>({
  chatMessages: [],
  messageInput: "",
  setMessageInput: () =>  console.warn('ChatProvider not yet initialized.'),
  sendTextMessage: () =>  console.warn('ChatProvider not yet initialized.'),
  sendAudioMessage: () =>  console.warn('ChatProvider not yet initialized.'),
});

// The custom hook for easy consumption
export const useChat = (): ChatContextType => {
  return useContext(ChatContext);
};

export default ChatContext;
